<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <template>
        <v-flex xs12 md12>
          <div>
            Caso essa obra esteja
            <b>editada</b> marque
            <u>"Essa obra está editada"</u>, caso
            <b>não esteja</b>, marque
            <u>"Direto com o Autor"</u>.
          </div>
          <v-radio-group v-model="obra_editada" row>
            <v-radio label="Direto com Autor" value="direto_autor"></v-radio>
            <v-radio label="Essa obra está editada" value="editada"></v-radio>
          </v-radio-group>
        </v-flex>
      </template>
      <template v-if="obra_editada!=null">
        <v-flex xs12 md12>
          <v-btn
            @click="dialog_editora=true"
            v-show="obra_editada=='editada'"
            color="success"
          >Adicionar Editora</v-btn>
          <v-btn @click="open_dialog_composer" color="primary">Adicionar Compositor Independente</v-btn>
          <v-divider></v-divider>
        </v-flex>
      </template>

      <!-- Editora -->
      <template v-if="publishers.length>0 && obra_editada=='editada' ">
        <v-flex xs12 md12>
          <v-form>
            <v-expansion-panel v-model="panel_editora" expand color="grey">
              <v-expansion-panel-content
                expand
                class="px-3"
                v-for="publisher in publishers"
                :key="publisher.row_count"
              >
                <template v-slot:actions>
                  <v-icon color="primary">$vuetify.icons.expand</v-icon>
                </template>
                <template v-slot:header>
                  <div>
                    <strong>
                      Editora  
                      <template v-if="publisher.name"> - {{publisher.name}} </template>
                      <template v-if="publisher.br_razao_social"> - {{publisher.br_razao_social}}</template>
                    </strong>
                    
                  </div>
                  <v-spacer></v-spacer>
                  <v-btn small style="max-width:130px!important" @click="open_dialog_composer(publisher)" color="primary">+ compositor</v-btn>
                </template>
                <v-divider></v-divider>

                <v-layout wrap class="my-4">
                  <v-flex xs12 md5>
                    <v-text-field
                      v-model="publisher.name"
                      disabled
                      class="purple-input"
                      label="Compositor"
                    />
                  </v-flex>

                  <v-flex xs12 md5>
                    <v-text-field
                      v-model="publisher.pivot.share"
                      class="purple-input"
                      label="Participação"
                      messages="A % que essa pessoa tem sobre o artista."
                      suffix="%"
                      v-mask="['##.##','###.##']"
                    />
                  </v-flex>

                  <v-flex xs12 md1>
                    <v-btn  dark small color="error">
                      Remover Editora
                    </v-btn>
                  </v-flex>
                  <div style="background-color:#ccc; width:100%,  " class="flex xs12 md12">
                    <listwithshare :composers="composers" :updated="update_editora_time" :publisher_id="publisher.id" @composers_changed="composers_changed" @remove_person="remove_person" />
                  </div>
                </v-layout>

                <v-layout>
                    
                </v-layout>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-form>
        </v-flex>
      </template>

      <!--compositores -->
      <!-- ENTRA AQUI -->
      <listwithshare :composers="composers" @composers_changed="composers_changed" @remove_person="remove_person" />

    </v-layout>
    <!-- DIALOG COMPOSER-->
    <v-dialog v-model="dialog_composer" persistent max-width="600px">
      <v-card>
        <v-card-title style="background-color:#1976d2" class="white--text">
          <span class="headline">Buscar e Adicionar Compositor</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-flex xs12 sm12 md12>
              <v-autocomplete
                v-model="item_selected"
                :items="items"
                :loading="isLoading"
                :search-input.sync="search"
                item-text="name"
                item-value="id"
                label="Compositor"
                placeholder="Busque pelo compositor"
                prepend-icon="mdi-database-search"
                no-data-text="Nada por enquanto"
                return-object
              ></v-autocomplete>
            </v-flex>
          </v-container>
          <small>
            Busque pelo compositor digitando o seu nome e clique em seu nome para selecionar.
            <br />Para adicionar mais de um continue buscando e selecionando.
          </small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <!--v-btn color="blue darken-1" flat @click="dialog_composer = false">Close</v-btn-->
          <v-btn color="blue darken-1" flat @click="dialog_composer = false">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- DIALOG PUBLISHER -->
    <v-dialog v-model="dialog_editora" persistent max-width="600px">
      <v-card>
        <v-card-title style="background-color:#4caf50" class="white--text">
          <span class="headline">
            <b>Buscar e Adicionar Editora</b>
          </span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-flex xs12 sm12 md12>
              <v-autocomplete
                v-model="item_editora_selected"
                :items="items_editora"
                :loading="isLoadingEditora"
                :search-input.sync="searchEditora"
                item-text="name"
                item-value="id"
                label="Editora"
                placeholder="Busque pela Editora"
                prepend-icon="mdi-database-search"
                no-data-text="Nada por enquanto"
                return-object
              ></v-autocomplete>
            </v-flex>
          </v-container>
          <small>
            Busque pelo compositor digitando o seu nome e clique em seu nome para selecionar.
            <br />Para adicionar mais de um continue buscando e selecionando.
          </small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <!--v-btn color="blue darken-1" flat @click="dialog_composer = false">Close</v-btn-->
          <v-btn color="blue darken-1" flat @click="dialog_editora = false">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>

import ComposerService from "../../app/Rest/composer";
import PublisherService from "../../app/Rest/publishers";
import listwithshare from './list_with_share';

const composerService = ComposerService.build();
const publisherService = PublisherService.build();

export default {
  components:{
    listwithshare
  },
  data() {
    return {
      dialog_composer: false,
      dialog_editora: false,
      obra_editada: null,
      count_composers: 0,
      count_publishers: 0,
      update_editora_time: null,
      panel: [true],
      panel_editora: [true],
      composers: [], //{ row_count: 0, expanded: true }
      publishers: [],
      publishers_selected:null, //preenchido quando é adicionado um novo compositor
      items: [],
      items_editora: [],
      select: null,
      cpf_consulta: null,
      descriptionLimit: 60,
      entries: [],
      isLoading: false,
      isLoadingEditora: false,
      item_selected: null,
      item_editora_selected: null,
      search: null,
      searchEditora: null
    };
  },
  props: {
    composersdata: Array,
    publishersdata: Array,
    worktype: String
  },
  methods: {
    composers_changed: function(e){
      console.log("vindo aqui, composers changed");
      this.composers = e;
    },
    add_editora: function(editora) {
      this.count_publishers = this.count_publishers + 1;

      if (editora != null) {
        editora.row_count = this.count_publishers;
        //se nao houver o pivot, criamos um temporario
        if (editora.pivot == null) {
          editora.pivot = { share: "" };
        }
      } else {
        editora = {};
        editora = {
          row_count: this.count_publishers,
          pivot: {},
          composers:[]
        };
      }

      //se já estiver, não precisamos adicionar novamente
      for (var a = 0; a < this.publishers.length; a++) {
        if (editora.id == this.publishers[a].id) {
          return;
        }
      }

      this.publishers.push(editora);
    },
    //Adiciona uma pessoa ao conjunto atual
    add_person: function(p_person) {
      this.count_composers = this.count_composers + 1;
      var composers_container = [];
      //if(this.publishers_selected!==null){
      //  if(!this.publishers_selected.composers)
      //    this.publishers_selected.composers = [];

      //  composers_container = this.publishers_selected.composers;
      //}else{
        composers_container = this.composers;
      //}

      //panel.push(false);
      if (p_person != null) {
        p_person.row_count = this.count_composers;
        //se nao houver o pivot, criamos um temporario
        if (p_person.pivot == null) {
          p_person.pivot = { share: "" };
        }
      } else {
        p_person = {};
        p_person = {
          row_count: this.count_composers,
          cpf: this.cpf_consulta,
          pivot: {}
        };
      }
      console.log(composers_container);
      for (var a = 0; a < composers_container.length; a++) {
        if (p_person.id == composers_container[a].id) {
          return;
        }
      }
    
    console.log("add_person", this.publishers_selected);
    if(this.publishers_selected!==null){
      p_person.pivot.publisher_id = this.publishers_selected.id;
    }

      composers_container.push(p_person);
      //console.log("adicionando pessoa ao composer", this.publishers_selected, composers_container, this.publishers);
      //this.publishers.push({});
      //this.publishers.pop();
      this.update_editora_time = new Date();
      this.cpf_consulta = null;
    },
    remove_person: function(person) {
      var t_faixas = [];
      this.composers.forEach(element => {
        console.log(person.id, element.id);
        if (person.id != element.id) {
          t_faixas.push(element);
        }
      });
      this.composers = t_faixas;
      console.log("remove_person", this.composers);
      this.count_composers = this.count_faixas - 1;
    },
    open_dialog_composer: function(e,a){  
      console.log("open dialog composer", e);
      if(e){
        this.publishers_selected = e;
      }
      this.dialog_composer=true
    }
  },
  watch: {
    worktype:function(){
      this.obra_editada = this.worktype;
    },
    publishers:{
      handler: function(e,v) {        
        this.$emit("publishers_data", this.publishers); 
      },
      deep:true
    },
    obra_editada: function() {
      this.$emit("work_type", this.obra_editada);
    },
    composers: {
      handler: function(e,v) {
        //console.log("composer editado ", e,v, this.composers);
        console.log("editado ", this.composers);
        this.$emit("composers_data", this.composers);        
      },
      deep:true
    },
    publishersdata:function(){
      this.publishers = this.publishersdata;
    },
    composersdata: function() {
      console.log("aqui veio");
      this.composers = this.composersdata;
    },
    item_selected: function() {
      if (this.item_selected == null) return;

      this.add_person(this.item_selected);
      this.item_selected = null;
    },
    item_editora_selected: function() {
      if (this.item_editora_selected == null) return;
      console.log("item editora selected", this.item_editora_selected);
      this.add_editora(this.item_editora_selected);
      this.item_editora_selected = null;
    },
    //search compositor
    search(val) {      
      if (val == null || val == "") return;

      this.isLoading = true;

      composerService.searchCompositor(val).then(e => {
        this.items = e.items.composers.data;
        this.isLoading = false;
      });
    },
    //search editora
    searchEditora(val) {      
      if (val == null || val == "") return;

      this.isLoadingEditora = true;

      publisherService.searchEditora(val).then(e => {
        console.log(e.items.publishers.data);

        this.items_editora = e.items.publishers.data;
        this.isLoadingEditora = false;
      });
    }
  }
};
</script>
